/**
 * Libraries
 */

import * as Sentry from '@sentry/vue';

/**
 * Config
 */

import { isProd } from './env';

/**
 * Types
 */

import type { App } from 'vue';
import type { Router } from 'vue-router';

function setupSentry(app: App<Element>, router: Router) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    trackComponents: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: isProd,
        blockAllMedia: isProd,
      }),
    ],
    tracePropagationTargets: [
      import.meta.env.VITE_APP_NAME,
      import.meta.env.VITE_APP_API_URL,
    ],
    replaysSessionSampleRate: 0.1,
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Session Replay
    replaysOnErrorSampleRate: isProd ? 0 : 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

export { setupSentry };
